module.exports = __webpack_public_path__ + "img/icon_open.2014498c.svg";